export default defineNuxtPlugin({
  name: 'auth-init',
  dependsOn: ['pinia', 'http'],
  async setup() {
    if (true) {
      const { $pinia } = useNuxtApp();
      const auth = useAuthStore($pinia);
      await auth.init();
    }

    return {};
  },
  hooks: {}
});
